<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="formGroups"
      :viewMode="viewMode" @onChange="onChange">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "StaffCaptainDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      form: {
        name: undefined,
        sex: '男',
        birthday: undefined,
        tel: undefined,
        nation: undefined,
        province: undefined,
        address: undefined,
        contact: undefined,
        contacttel: undefined,
        identitycard: undefined,
        username: undefined,
        password: undefined,
      },
      breadcrumb: [
        { name: "人员管理", path: "/staff/captain" },
        { name: "车队长管理", path: "/staff/captain" },
        { name: "添加车队长" },
      ],
      formGroups: [
        {
          title: '基础信息',
          formCtrl: [
            {
              label: "姓名",
              keyName: "name",
              err: "请填写姓名",
              type: "text",
            },
            {
              label: "性别",
              keyName: "sex",
              err: "请选择性别",
              type: "select",
              options: [
                { label: '男', value: '男' },
                { label: '女', value: '女' },
              ],
            },
            {
              label: "出生年月",
              keyName: "birthday",
              err: "请选择出生年月",
              type: "date",
            },
            {
              label: "入职时间",
              keyName: "entrytime",
              err: "请选择入职时间",
              type: "date",
            },
            {
              label: "状态",
              keyName: "iswork",
              err: "请选择状态",
              type: "select",
              options: [],
            },
            {
              label: "学历",
              keyName: "edu",
              err: "请选择学历",
              type: "select",
              options: [],
            },
            {
              label: "联系方式",
              keyName: "tel",
              err: "请填写联系方式",
              type: "text",
            },
            {
              label: "民族",
              keyName: "nation",
              err: "请填写民族",
              type: "text",
            },
            {
              label: "籍贯",
              keyName: "province",
              err: "请填写籍贯",
              type: "text",
            },
            {
              label: "住址",
              keyName: "address",
              err: "请填写住址",
              type: "text",
            },
            {
              label: "紧急联系人",
              keyName: "contact",
              err: "请填写紧急联系人姓名",
              type: "text",
            },
            {
              label: "紧急联系人联系方式",
              keyName: "contacttel",
              err: "请填写紧急联系人联系方式",
              type: "text",
            },
            {
              label: "身份证正反面",
              keyName: "identitycard",
              type: "file",
              tips: "最多上传2张图片",
              max: 2,
              className: "block",
            },
            {
              label: "无犯罪记录证明",
              keyName: "not_crime",
              type: "file",
              tips: "最多上传2张图片",
              max: 2,
              className: "block",
            },
            {
              label: "签名凭证",
              keyName: "sign",
              type: "file",
              tips: "最多上传1张图片",
              max: 1,
              className: "block",
            },
          ],
        },
        {
          title: '账号信息',
          formCtrl: [
            {
              label: "账号",
              keyName: "username",
              err: "请填写账号",
              type: "text",
            },
            {
              label: "密码",
              keyName: "password",
              err: "请填写密码",
              type: "password",
            },
          ],
        },
      ],
    };
  },
  methods: {
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (['sign'].includes(key) && value.length == 1 && value[0] && value[0].response) {
        this.form[key] = value[0].response.photo
      }
    },
  },
  created() {
    this.form['user_group_id'] = 5
    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
